import { render } from "./RecordDetail.vue?vue&type=template&id=0e15c87c&scoped=true"
import script from "./RecordDetail.vue?vue&type=script&lang=js"
export * from "./RecordDetail.vue?vue&type=script&lang=js"

import "./RecordDetail.vue?vue&type=style&index=0&id=0e15c87c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e15c87c"]])

export default __exports__